import "./index.css";



function Notification(){	

	return(

		<section id='notification'>

			<p>
				
			</p>

		</section>


		)
};

export default Notification;